import { formatDealValue } from '@/utils/dealDisplay'
import { cn } from '@/utils/cn'
import type { JourneyColumnMetrics } from '@/components/Deals/journeyColumnMetrics'

type JourneyColumnStatsProps = {
  metrics: JourneyColumnMetrics
  areValuesVisible?: boolean
}

function StatCell({
  label,
  value,
  warn,
  title,
}: {
  label: string
  value: string
  warn?: boolean
  title?: string
}) {
  return (
    <div className='min-w-0' title={title}>
      <p className='text-[10px] leading-none text-text-muted'>{label}</p>
      <p
        className={cn(
          'mt-1 truncate text-xs font-semibold tabular-nums leading-none',
          warn ? 'text-warning' : 'text-text-primary',
        )}
      >
        {value}
      </p>
    </div>
  )
}

export function JourneyColumnStats({ metrics, areValuesVisible = false }: JourneyColumnStatsProps) {
  if (metrics.count === 0) return null

  return (
    <div className='deals-journey-column-stats mt-2.5 rounded-lg border border-[color-mix(in_srgb,var(--stage-color,var(--border))_20%,var(--border))] bg-[color-mix(in_srgb,var(--stage-color)_6%,var(--bg-dark))] px-2.5 py-2'>
      <dl className='grid grid-cols-2 gap-x-3 gap-y-2.5'>
        <StatCell
          label='Valor total'
          value={formatDealValue(metrics.value, areValuesVisible, true)}
        />
        <StatCell
          label='Tempo médio'
          value={`${metrics.avgAging}d`}
          title='Média de dias na etapa atual'
        />
        <StatCell
          label='Maior parada'
          value={`${metrics.maxAging}d`}
          warn={metrics.maxAging >= 5}
          title='Deal há mais tempo parado nesta coluna'
        />
        <StatCell
          label='Em risco'
          value={metrics.atRisk > 0 ? String(metrics.atRisk) : 'Nenhuma'}
          warn={metrics.atRisk > 0}
          title='Negociações fora do SLA ou estagnadas'
        />
      </dl>
    </div>
  )
}
